import { useEffect, useState } from "react";
import { Button, Label, Menu, Tab } from "semantic-ui-react";
import "./styles.module.css";
import styles from "./styles.module.css";
import Modal from "../../../app/common/modals/Custom";
import AllOrders from "./tables/AllOrders";
import { FilterModal } from "../../../app/common/helpers";
import { ReactComponent as SvgSearchIcon } from "../../../assets/searchIcon.svg";
import { ReactComponent as GreenDropDownIcon } from "../../../assets/greendropdown.svg";
import { ReactComponent as ThumbsUpSvg } from "../../../assets/navbericon/thumbsup.svg";
import { observer } from "mobx-react-lite";
import TablePlaceholder from "./tables/TablePlaceholder";
import { useStore } from "../../../app/stores/store";
import Loading from "../../../app/layout/Loading";
import { IOrderItem } from "../../../app/models/orders";

const OrdersIndex = () => {
  const [currentFilter, setCurrentFilter] = useState({ value: "", code: 100 });
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPagePending, setCurrentPagePending] = useState(1);
  const [currentPageCompleted, setCurrentPageCompleted] = useState(1);
  const [currentPageCancelled, setCurrentPageCancelled] = useState(1);
  const [currentPageReturned, setCurrentPageReturned] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [modal, setModal] = useState("");
  const { orderStore } = useStore();
  const {
    loadingInitial,
    loading,
    vendorOrderItemList,
    vendorPendingOrderItemList,
    vendorCompletedOrderItemList,
    vendorCancelledOrderItemList,
    vendorReturnedOrderItemList,
    getVendorOrders,
    updateOrders,
  } = orderStore;
  const [inputField, setInputField] = useState<IOrderItem[]>([]);
  const [test, setTest] = useState<any[]>([]);
  const statuses = [
    { name: "Newest to Oldest", code: 0 },
    { name: "Oldest to Newest", code: 1 },
    { name: "Completed", code: 2 },
    { name: "Pending", code: 3 },
    { name: "Cancelled", code: 4 },
  ];

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement>, 
  ) => {
    // setCurrentPage(1); // Reset the page to 1
    setSearchTerm(e.target.value); // Update the search term
    if(e.target.value){
      getVendorOrders(searchTerm);
    }else {
      getVendorOrders("");
    }
  };

  const filteredVendorOrderItemList = vendorOrderItemList
    // .filter((val) => {
    //   if (searchTerm === "") {
    //     return val;
    //   } else if (
    //     val.productName != null 
    //   ) {
    //     return val;
    //   } else {
    //     return null;
    //   }
    // })
    .filter((fil) => {
      if (currentFilter.code >= 100) {
        return fil;
      } else if (
        currentFilter.code === 2 ||
        currentFilter.code === 3 ||
        currentFilter.code === 4
      ) {
        return statuses[currentFilter.code].name === fil.status;
      }
      return fil;
    })
    .sort(function (x, y) {
      if (currentFilter.value === "Newest to Oldest") {
        let a = new Date(x.dateCreated.split("|")[0]).getTime(),
          b = new Date(y.dateCreated.split("|")[0]).getTime();
        return b - a;
      } else if (currentFilter.value === "Oldest to Newest") {
        let b = new Date(x.dateCreated.split("|")[0]).getTime(),
          a = new Date(y.dateCreated.split("|")[0]).getTime();
        return b - a;
      } else {
        let a = new Date(x.dateCreated.split("|")[0]).getTime(),
          b = new Date(y.dateCreated.split("|")[0]).getTime();

        return b - a;
      }
    });

  const filteredVendorPendingOrderItemList = vendorPendingOrderItemList
    .filter((val) => {
      if (searchTerm === "") {
        return val;
      } else if (
        val.productName != null 
      ) {
        return val;
      } else {
        return null;
      }
    })
    .sort(function (x, y) {
      if (currentFilter.value === "Newest to Oldest") {
        let a = new Date(x.dateCreated.split("|")[0]).getTime(),
          b = new Date(y.dateCreated.split("|")[0]).getTime();
        return b - a;
      } else if (currentFilter.value === "Oldest to Newest") {
        let b = new Date(x.dateCreated.split("|")[0]).getTime(),
          a = new Date(y.dateCreated.split("|")[0]).getTime();
        return b - a;
      } else {
        let a = new Date(x.dateCreated.split("|")[0]).getTime(),
          b = new Date(y.dateCreated.split("|")[0]).getTime();

        return b - a;
      }
    });

  const filteredVendorCompletedOrderItemList = vendorCompletedOrderItemList
    .filter((val) => {
      if (searchTerm === "") {
        return val;
      } else if (
        val.productName != null 
      ) {
        return val;
      } else {
        return null;
      }
    })
    .sort(function (x, y) {
      if (currentFilter.value === "Newest to Oldest") {
        let a = new Date(x.dateCreated.split("|")[0]).getTime(),
          b = new Date(y.dateCreated.split("|")[0]).getTime();
        return b - a;
      } else if (currentFilter.value === "Oldest to Newest") {
        let b = new Date(x.dateCreated.split("|")[0]).getTime(),
          a = new Date(y.dateCreated.split("|")[0]).getTime();
        return b - a;
      } else {
        let a = new Date(x.dateCreated.split("|")[0]).getTime(),
          b = new Date(y.dateCreated.split("|")[0]).getTime();

        return b - a;
      }
    });

  const filteredVendorCancelledOrderItemList = vendorCancelledOrderItemList
    .filter((val) => {
      if (searchTerm === "") {
        return val;
      } else if (
        val.productName != null 
      ) {
        return val;
      } else {
        return null;
      }
    })
    .sort(function (x, y) {
      if (currentFilter.value === "Newest to Oldest") {
        let a = new Date(x.dateCreated.split("|")[0]).getTime(),
          b = new Date(y.dateCreated.split("|")[0]).getTime();
        return b - a;
      } else if (currentFilter.value === "Oldest to Newest") {
        let b = new Date(x.dateCreated.split("|")[0]).getTime(),
          a = new Date(y.dateCreated.split("|")[0]).getTime();
        return b - a;
      } else {
        let a = new Date(x.dateCreated.split("|")[0]).getTime(),
          b = new Date(y.dateCreated.split("|")[0]).getTime();

        return b - a;
      }
    });

  const filteredVendorReturnedOrderItemList = vendorReturnedOrderItemList
    .filter((val) => {
      if (searchTerm === "") {
        return val;
      } else if (
        val.productName != null 
      ) {
        return val;
      } else {
        return null;
      }
    })
    .sort(function (x, y) {
      if (currentFilter.value === "Newest to Oldest") {
        let a = new Date(x.dateCreated.split("|")[0]).getTime(),
          b = new Date(y.dateCreated.split("|")[0]).getTime();
        return b - a;
      } else if (currentFilter.value === "Oldest to Newest") {
        let b = new Date(x.dateCreated.split("|")[0]).getTime(),
          a = new Date(y.dateCreated.split("|")[0]).getTime();
        return b - a;
      } else {
        let a = new Date(x.dateCreated.split("|")[0]).getTime(),
          b = new Date(y.dateCreated.split("|")[0]).getTime();

        return b - a;
      }
    });

  const panes = [
    {
      menuItem: "All Orders",
      render: () =>
        loadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllOrders
            orderItemList={filteredVendorOrderItemList}
            inputField={inputField}
            setInputField={setInputField}
            test={test}
            setTest={setTest}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        ),
    },
    {
      menuItem: (
        <Menu.Item
          key={"pending"}
          style={{
            fontFamily: "Montserrat",
            fontSize: "13px",
          }}
        >
          Pending Orders
          <Label circular color={"red"} size={"mini"}>
            {filteredVendorPendingOrderItemList.length}
          </Label>
        </Menu.Item>
      ),
      render: () =>
        loadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllOrders
            orderItemList={filteredVendorPendingOrderItemList}
            inputField={inputField}
            setInputField={setInputField}
            test={test}
            setTest={setTest}
            currentPage={currentPagePending}
            setCurrentPage={setCurrentPagePending}
          />
        ),
    },
    {
      menuItem: (
        <Menu.Item
          key={"completed"}
          style={{
            fontFamily: "Montserrat",
            fontSize: "13px",
          }}
        >
          Completed Orders
          <Label circular color={"red"} size={"mini"}>
            {filteredVendorCompletedOrderItemList.length}
          </Label>
        </Menu.Item>
      ),
      render: () =>
        loadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllOrders
            orderItemList={filteredVendorCompletedOrderItemList}
            inputField={inputField}
            setInputField={setInputField}
            test={test}
            setTest={setTest}
            currentPage={currentPageCompleted}
            setCurrentPage={setCurrentPageCompleted}
          />
        ),
    },
    {
      menuItem: (
        <Menu.Item
          key={"cancelled"}
          style={{
            fontFamily: "Montserrat",
            fontSize: "13px",
          }}
        >
          Cancelled Orders
          <Label circular color={"red"} size={"mini"}>
            {filteredVendorCancelledOrderItemList.length}
          </Label>
        </Menu.Item>
      ),
      render: () =>
        loadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllOrders
            orderItemList={filteredVendorCancelledOrderItemList}
            inputField={inputField}
            setInputField={setInputField}
            test={test}
            setTest={setTest}
            currentPage={currentPageCancelled}
            setCurrentPage={setCurrentPageCancelled}
          />
        ),
    },
    {
      menuItem: (
        <Menu.Item
          key={"returned"}
          style={{
            fontFamily: "Montserrat",
            fontSize: "13px",
          }}
        >
          Returned Orders
          <Label circular color={"red"} size={"mini"}>
            {filteredVendorReturnedOrderItemList.length}
          </Label>
        </Menu.Item>
      ),
      render: () =>
        loadingInitial === "loading" ? (
          <TablePlaceholder />
        ) : (
          <AllOrders
            orderItemList={filteredVendorReturnedOrderItemList}
            inputField={inputField}
            setInputField={setInputField}
            test={test}
            setTest={setTest}
            currentPage={currentPageReturned}
            setCurrentPage={setCurrentPageReturned}
          />
        ),
    },
  ];

  useEffect(() => {
    getVendorOrders(searchTerm);
  }, []);
  return (
    <div className={styles.page}>
      {(loadingInitial === "loading" || loading) && <Loading />}
      {modal && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => setModal("")}
        >
          <div className={styles.verifyAccountModal}>
            {/* <h2>Activate Selling Permission</h2> */}

            <div className={styles.info}>
              {" "}
              <ThumbsUpSvg />
            </div>
            <div className={styles.welcomeText}>
              <p>Mark these as Completed Orders?</p>
            </div>

            <div className={styles.twoButton}>
              <Button
                positive
                className={styles.negative}
                onClick={() => setModal("")}
              >
                <div className={styles.button}>
                  <span>Cancel</span>
                </div>
              </Button>
              <Button
                positive
                className={styles.activate}
                onClick={() =>
                  updateOrders(inputField)
                    .then((res) => {
                      if (res.isSuccessful) {
                        setInputField([]);
                        setTest([]);
                      }
                    })
                    .finally(() => setModal(""))
                }
              >
                <div className={styles.button}>
                  <span>Yes, Please do!</span>
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}
      <div className={styles.header}>
        Orders
        <div className={styles.searchAndFilter}>
          <div>
            <div className={`${styles.hassearch}`}>
              {/* <span className="fa fa-search form-control-feedback"></span> */}
              <SvgSearchIcon className={styles.formcontrolfeedback} />
              <input
                type="text"
                className={styles.formcontrol}
                placeholder="Search Orders, Order Number, name"
                onChange={(e) => {
                  handleSearchChange(e)
                }}
              />
            </div>
          </div>
          <FilterModal
            options={[
              ...[...statuses].map((status, index) => ({
                code: index,
                value: status.name,
              })),
              { value: "None", code: 100 },
            ]}
            onSelect={(e) => setCurrentFilter({ value: e.value, code: e.code })}
            selected={currentFilter.code}
          />
        </div>
      </div>
      {inputField.length > 0 && (
        <div className={styles.sider}>
          <div
            className={styles.completedDropDown}
            onClick={() => setModal("1")}
          >
            <span>
              <GreenDropDownIcon />
            </span>
            Mark as Completed{" "}
          </div>
          <div
            className={styles.undoDropDown}
            onClick={() => setInputField([])}
          >
            <span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.87744 9.69336H16.4789C18.6203 9.69336 20.3563 11.4294 20.3563 13.5707C20.3563 15.7121 18.6203 17.4481 16.4789 17.4481H11.6322"
                  stroke="black"
                  strokeWidth="1.93869"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.78559 5.81543L2.9082 9.69281L6.78559 13.5702"
                  stroke="black"
                  strokeWidth="1.93869"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            Undo{" "}
          </div>
        </div>
      )}
      <div
        className={`${styles.tableSection} ${
          inputField.length > 0 && styles.checked
        }`}
      >
        <div className="section">
          <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
        </div>
      </div>
    </div>
  );
};

export default observer(OrdersIndex);
